// src/utils/fecha.js
const TZ = "Europe/Madrid";
const HAS_TZ = /([zZ]|[+\-]\d{2}:?\d{2})$/; // Z o +hh(:)mm al final

// Si el ISO no trae zona, asumimos UTC (añadimos 'Z')
export const parseISO = (iso) => {
  if (!iso) return null;
  if (iso instanceof Date) return iso;
  const s = String(iso).trim();
  return new Date(HAS_TZ.test(s) ? s : s + "Z");
};

const isValid = (d) => d instanceof Date && !isNaN(d);

// ==== Hora / Fecha (formato español, zona Madrid) ====
export const fmtHoraISO = (iso) => {
  const d = parseISO(iso);
  if (!isValid(d)) return "";
  return d.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: TZ,
  });
};

// Alias usado en tablas (equivalente a fmtHoraISO)
export const fmtHoraCorta = (iso) => fmtHoraISO(iso);

export const fmtFechaISO = (iso) => {
  const d = parseISO(iso);
  if (!isValid(d)) return "";
  return d.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: TZ,
  });
};

// Alias usado en tablas (equivalente a fmtFechaISO)
export const fmtFechaCorta = (iso) => fmtFechaISO(iso);

export const fmtFechaHoraISO = (iso) =>
  iso ? `${fmtFechaISO(iso)} · ${fmtHoraISO(iso)}` : "";

// Devuelve YYYY-MM-DD calculado en la TZ configurada
export const yyyymmddTZ = (isoOrDate) => {
  const d = parseISO(isoOrDate) || new Date();
  const s = d.toLocaleDateString("es-ES", {
    timeZone: TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  //  dd/mm/aaaa -> aaaa-mm-dd
  const [dd, mm, yyyy] = s.split("/");
  return `${yyyy}-${mm}-${dd}`;
};

// ===== Utilidades opcionales =====

// Normaliza "HH:mm" (o Date/ISO) a "HH:mm". Si no es válido, devuelve "".
export const toHHmm = (value) => {
  if (!value) return "";
  const s = String(value);
  if (/^\d{2}:\d{2}/.test(s)) return s.slice(0, 5);
  const d = parseISO(value);
  return isValid(d) ? fmtHoraISO(d.toISOString()) : "";
};